import React from 'react';

type Props = {
  className?: string;
};

export const PDFWhySwitch: React.FC<Props> = ({ className }) => {
  return (
    <>
      <div className={`${className}`}>
        <p className="text-center text-2xl mx-auto tracking-tight font-bold  sm:text-3xl md:text-3xl lg:w-2/3">
          <span className="block text-gray-900">
            Why are restaurants switching from PDFs to TableTab?
          </span>
        </p>
        <div
          className={
            'mt-10 grid grid-cols-1 gap-y-6 md:grid-cols-3 md:gap-x-4 lg:gap-x-8 xl:gap-x-10'
          }
        >
          <div className={'w-4/5 sm:w-3/4 md:w-full mx-auto'}>
            <div className={'bg-orange-200 rounded-xl shadow-md'}>
              <div className={' lg:p-10 2xl:p-16 md:p-6 p-16 mx-auto'}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className={'text-orange-800'}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={0.5}
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
            </div>
            <div className={'mt-6 text-gray-900'}>
              <p className="text-xl mx-auto tracking-tight font-bold  sm:text-2xl md:text-2xl">
                <span className="block text-gray-900">
                  Simple visual scrolling
                </span>
              </p>
              <p className="text-base mx-auto  sm:text-lg text-gray-900 my-4">
                With our{' '}
                <a
                  className={'text-primary-600 hover:text-primary-700'}
                  href={'/product#digital-menus'}
                >
                  {' '}
                  picture-oriented, mobile-friendly menus
                </a>
                , guests don't have to pinch and zoom in on low quality PDFs.
                {/* TableTab makes it easy to promote your newest items, test specials on the fly,
                and automate upselling. Let’s see your PDF do that. */}
              </p>
            </div>
          </div>

          <div className={'w-4/5 sm:w-3/4 md:w-full mx-auto'}>
            <div className={'bg-primary-200 rounded-xl shadow-md mx-auto'}>
              <div className={' lg:p-10 2xl:p-16 md:p-6 p-16 mx-auto'}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className={'text-primary-900 mx-auto '}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={0.5}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
              </div>
            </div>
            <div className={'mt-6 text-gray-900'}>
              <p className="text-xl mx-auto tracking-tight font-bold  sm:text-2xl md:text-2xl">
                <span className="block text-gray-900">
                  Smart and informative
                </span>
              </p>
              <p className="text-base mx-auto  sm:text-lg  text-gray-900 my-4">
                Automatically show guests the{' '}
                <a
                  className={'text-primary-600 hover:text-primary-700'}
                  href={'/product#menu-management'}
                >
                  right menu at the right time
                </a>
                , polished with images and your preferred modifiers.
                {/* It's Every time your guest uses a PDF menu, you’re missing out on
                capturing valuable data and insights to power your restaurant.
                TableTab puts powerful analytics at your fingertips to help you
                understand guest behavior, maximize your digital marketing.ts
                results, determine which menu items are most popular for use in
                promotions and earn your guests’ contact information to engage
                with local customers over time. */}
              </p>
            </div>
          </div>
          <div className={'w-4/5 sm:w-3/4 md:w-full mx-auto'}>
            <div className={'bg-purple-200 rounded-xl shadow-md'}>
              <div className={'lg:p-10 2xl:p-16 md:p-6 p-16 mx-auto'}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className={'text-purple-900'}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={0.5}
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
            </div>
            <div className={'mt-6 text-gray-900'}>
              <p className="text-xl mx-auto tracking-tight font-bold  sm:text-2xl md:text-2xl">
                <span className="block text-gray-900">
                  Direct ordering feature
                </span>
              </p>
              <p className="text-base mx-auto  sm:text-lg text-gray-900 my-4">
                Our menus are pretty smart - if you want, guests can click on
                whichever items they like and{' '}
                <a
                  className={'text-primary-600 hover:text-primary-700'}
                  href={'/product#order-pay'}
                >
                  {' '}
                  order it immediately
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
